import { ChangeDetectionStrategy, Component, Input, Type } from '@angular/core';
import { SpotlightEvent } from 'src/app/dto';
import { SpotlightCardComponent } from '../spotlight-card/spotlight-card.component';

// Kind -> specialized component registry, mirroring NODE_COMPONENT_REGISTRY (node-renderer.component.ts).
// Empty for now: every Kind renders via the generic SpotlightCardComponent fallback until a Kind
// needs bespoke rendering - unlike node-renderer's UnknownNodeComponent fallback (which renders
// nothing), Spotlight's fallback must always render something, since every event needs a card.
const SPOTLIGHT_COMPONENT_REGISTRY: Partial<Record<string, Type<unknown>>> = {};

@Component({
    selector: 'app-spotlight',
    templateUrl: './spotlight.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpotlightComponent {
    @Input() event: SpotlightEvent;

    get component(): Type<unknown> {
        return SPOTLIGHT_COMPONENT_REGISTRY[this.event?.Kind] ?? SpotlightCardComponent;
    }

    get inputs(): Record<string, unknown> {
        return { event: this.event };
    }
}
